// config.js
export const BASE_URL = 'http://167.99.199.38/api';
//export const BASE_URL = 'http://localhost:9104/aperitivoDivinoServices';
